﻿const BUS_RATING = 3;
const POSITIONS_PER_BUS = 6;
const MAX_PER_POSITIONS = 8;
const DC_POWER_DISTRIBUTION_CATEGORY_ID = 19;
const MAIN_CATEGORY = 0;
const ELECTRICAL_ATTRIBUTES = 3;
const CATEGORY_SITE = 1;
const HEIGHT_ATT_TITLE = "Height";
const DEPTH_ATT_TITLE = "Depth";
const WIDTH_ATT_TITLE = "Width";
const PACKAGE_WIDTH_ATT_TITLE = "Packaged Width";
const PACKAGE_LENGTH_ATT_TITLE = "Packaged Length";
const PACKAGE_DEPTH_ATT_TITLE = "Packaged Depth";
const RATIO_CONVERT_INC_CM = 2.54;
const LOCALSTORAGE_METRIC_KEY = "isMetric";
const DOCUMENT_TYPE = Object.freeze({
    DATASHEET: 'Datasheet',
    INSTALLATION: 'Installation'
});

const CONVERSION_ATTRIBUTES = [
    HEIGHT_ATT_TITLE,
    DEPTH_ATT_TITLE,
    WIDTH_ATT_TITLE,
    PACKAGE_WIDTH_ATT_TITLE,
    PACKAGE_LENGTH_ATT_TITLE,
    PACKAGE_DEPTH_ATT_TITLE
];

export {
    BUS_RATING,
    POSITIONS_PER_BUS,
    MAX_PER_POSITIONS,
    DC_POWER_DISTRIBUTION_CATEGORY_ID,
    ELECTRICAL_ATTRIBUTES,
    DOCUMENT_TYPE,
    CATEGORY_SITE,
    MAIN_CATEGORY,
    HEIGHT_ATT_TITLE,
    DEPTH_ATT_TITLE,
    WIDTH_ATT_TITLE,
    RATIO_CONVERT_INC_CM,
    PACKAGE_WIDTH_ATT_TITLE,
    PACKAGE_LENGTH_ATT_TITLE,
    PACKAGE_DEPTH_ATT_TITLE,
    CONVERSION_ATTRIBUTES,
    LOCALSTORAGE_METRIC_KEY
};